import auth from "../../../app-auth-container";

const Modules = {
  auth,
};

export default Modules;
